import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { CART_FEATURE } from './cart-state';
import { MULTI_CART_FEATURE } from './multi-cart-state';
import {
  multiCartMetaReducers,
  multiCartReducerProvider,
  multiCartReducerToken,
  reducerProvider,
  reducerToken,
} from './reducers';

@NgModule({
  imports: [
    StoreModule.forFeature(CART_FEATURE, reducerToken),
    StoreModule.forFeature(MULTI_CART_FEATURE, multiCartReducerToken, {
      metaReducers: multiCartMetaReducers,
    }),
  ],
  providers: [reducerProvider, multiCartReducerProvider],
})
export class CartStoreModule {}
